<template>
  <div class="active_rule_box">
    <div class="title"></div>
    <div v-for="(rule, index) in rules" :key="'rule' + index">
      <p class="rule-title">{{rule.title}}</p>
      <p class="rule-item" v-for="(ruleItem, ruleItemIndex) in rule.rules" :key="'ruleItem' + ruleItemIndex">{{ruleItem}}</p>
      <br>
    </div>
  </div>
</template>

<script>
let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "Rule",
  data() {
    return {
      rules: configs.GAME_INFO.rules
    }
  }
}
</script>

<style scoped>
.rule-title {
  font-weight: 800;
  font-size: 14px;
  padding-bottom: 4px;
}
.rule-item {
  padding-bottom: 4px;
}
</style>
